import React, { useState } from "react";
import { Card, FormGroup, Label, Row, Col, Input, Button } from "reactstrap";
import { connect } from "react-redux";
import { firstMileShipingList } from "reducers/FirstMileShipment";
import Table from "../../../components/Table";
import UploadForm from "../../../components/UploadModal";

const ViewManageCustomNotification = ({
  location,
  data
}) => {
  const [modal, setModal] = useState("");
  const rowData = location.state.detail;

  const handleSubmit = () => { };

  return (
    <Card>
      <div className="card-body p-4">
        <div>
          <Row>
            <Col>
              <Label className="font-weight-bold font-size-lg mb-4 d-flex align-items-center">
                {location.state.isEdit === true
                  ? "Edit Client Notification"
                  : "Client Notification"}
              </Label>
            </Col>
          </Row>
        </div>
        <div className="divider my-3" />
        <div>
          <FormGroup row>
            <Label for="exampleEmail" sm={2}>
              Flight Number
            </Label>
            <Col>
              <Input
                type="number"
                name="noOfShipment"
                id="exampleEmail"
                placeholder="#535335445"
                disabled={location.state.isEdit || location.state.isView}
              />
            </Col>
            <Label for="exampleEmail" sm={2}>
              MAWB #
            </Label>
            <Col>
              <Input
                type="number"
                name="totalWeight"
                id="exampleEmail"
                placeholder="10kg"
                disabled={location.state.isEdit || location.state.isView}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="exampleEmail" sm={2}>
              Total Weight
            </Label>
            <Col>
              <Input
                type="number"
                name="totalWeight"
                id="exampleEmail"
                placeholder="10kg"
                disabled={location.state.isEdit || location.state.isView}
              />
            </Col>
            <Label for="exampleEmail" sm={2}>
              No Of Shipments
            </Label>
            <Col>
              <Input
                type="number"
                name="totalWeight"
                id="exampleEmail"
                placeholder="10kg"
                disabled={location.state.isEdit || location.state.isView}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="exampleEmail" sm={2}>
              Estimated Time Departure
            </Label>
            <Col>
              <Input
                type="date"
                name="totalWeight"
                id="exampleEmail"
                placeholder="10kg"
                disabled={location.state.isEdit || location.state.isView}
              />
            </Col>
            <Label for="exampleEmail" sm={2}>
              Estimated Time Arrival
            </Label>
            <Col>
              <Input
                type="date"
                name="totalWeight"
                id="exampleEmail"
                placeholder="10kg"
                disabled={location.state.isEdit || location.state.isView}
              />
            </Col>
          </FormGroup>
        </div>

        <div className="divider my-3" />
        <Table
          tableLabel="Attachments"
          addButtonLabel={"Upload Attchment"}
          loading={data.isLoading}
          column={data.columns}
          data={[rowData]}
          showAddButton={location.state.isView ? false : true}
          onAdd={() => setModal("upload")}
          showActions={location.state.isView ? false : true}
        />
        {location.state.isEdit && (
          <Button
            onClick={handleSubmit}
            color="second"
            style={{ color: "#fff200" }}>
            {"Save Changes"}
          </Button>
        )}

        <UploadForm open={modal === "upload"} onClose={() => setModal("")} />
      </div>
    </Card>
  );
};

const mapStateToProps = ({ FirstMileShipment }) => ({
  data: FirstMileShipment
});

const mapDispatchToProps = {
  firstMileShipingList
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewManageCustomNotification);
